export const NotificationType = {
    "ERROR": 0,
    "WARNING": 1,
    "INFO": 2,
    "SUCCESS": 3
  }